export const TURN_ON_STRATEGY = 'turn-on-strategy';

export const TURN_OFF_STRATEGY = 'turn-off-strategy';
